module.exports = __webpack_public_path__ + "img/massenger.7ef8fe05.svg";